<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();

const isTeamsSettingsRoute = computed(() =>
  ['configuracoes_equipes', 'settings_teams_list'].includes(route.name)
);

const isProfileSettingsRoute = computed(() =>
  ['profile_settings_index', 'configuracoes_perfil'].includes(route.name)
);
</script>

<template>
  <div
    class="settings-wrapper flex flex-col w-full h-full m-0 pb-8 pt-4 overflow-auto bg-n-surface-1"
    :class="{
      'settings-wrapper--teams': isTeamsSettingsRoute,
      'settings-wrapper--profile': isProfileSettingsRoute,
      'px-6': !isTeamsSettingsRoute && !isProfileSettingsRoute,
    }"
  >
    <div
      v-if="isTeamsSettingsRoute"
      class="settings-wrapper__teams-header-outlet"
    />
    <div
      class="settings-wrapper__content flex items-start w-full"
      :class="
        isTeamsSettingsRoute
          ? 'settings-wrapper__content--teams'
          : isProfileSettingsRoute
            ? 'settings-wrapper__content--profile'
            : 'max-w-5xl mx-auto'
      "
    >
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" :key="route.fullPath" />
        </keep-alive>
        <component :is="Component" v-else :key="route.fullPath" />
      </router-view>
    </div>
  </div>
</template>

<style scoped>
.settings-wrapper--teams {
  position: relative;
  padding-top: 0;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  background: #f6f6f6;
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.42) transparent;
}

.settings-wrapper__teams-header-outlet {
  /* Header fixo dentro do scroll da página de equipes. */
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
  flex-shrink: 0;
  padding-top: 1rem;
  background: #f6f6f6;
  box-shadow: 0 1px 0 rgba(226, 232, 240, 0.9);
  isolation: isolate;
}

.settings-wrapper__teams-header-outlet::before {
  content: '';
  position: absolute;
  inset: 0 -2.5rem;
  z-index: -1;
  background: #f6f6f6;
}

.settings-wrapper--teams::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.settings-wrapper--teams::-webkit-scrollbar-track {
  background: transparent;
}

.settings-wrapper--teams::-webkit-scrollbar-thumb {
  background-color: rgba(148, 163, 184, 0.42);
  border-radius: 999px;
}

.settings-wrapper__content--teams {
  position: relative;
  z-index: 1;
  max-width: none;
  margin-left: 0;
  margin-right: 0;
}

.settings-wrapper--profile {
  flex: 1 1 auto;
  height: 100%;
  min-height: calc(100dvh - 4rem);
  margin: 0;
  padding: 0;
  padding-bottom: 0;
  background: #f6f6f6;
  overflow: hidden;
}

.settings-wrapper__content--profile {
  width: 100%;
  min-width: 0;
  height: 100%;
  min-height: calc(100dvh - 4rem);
  flex: 1;
  align-items: stretch;
  max-width: none;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}

.settings-wrapper__content--profile > :deep(.acl-profile-settings-workspace) {
  align-self: stretch;
  flex: 1 1 auto;
  min-height: 100%;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}
</style>
